exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer-btn {\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center; }\n\n.footer-btn button {\n  width: 75%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/edi/angular/app/modules/mobile/components/oes-workspace-selector/m-oes-workspace-selector.component.scss
// module id = ../../../../../angular/app/modules/mobile/components/oes-workspace-selector/m-oes-workspace-selector.component.scss
// module chunks = main